import { render, staticRenderFns } from "./ReceiptDisplay.vue?vue&type=template&id=8775ad64"
import script from "./ReceiptDisplay.vue?vue&type=script&lang=js"
export * from "./ReceiptDisplay.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDisplay.vue?vue&type=style&index=0&id=8775ad64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports